var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14.0 14.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 L14,13.9816 L0,13.9816 L0,0 L14,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02840155,0.49775 C9.69340155,-0.16625 10.8484016,-0.16525 11.5134016,0.49675 L13.4854016,2.47075 C13.8184016,2.80275 14.0004016,3.24375 14.0004016,3.71275 C14.0004016,4.18075 13.8184016,4.62275 13.4854016,4.95375 L5.22840155,13.21075 C5.07440155,13.36575 4.87140155,13.46575 4.65540155,13.49575 L1.00340155,13.98175 C0.736401554,13.98175 0.485401554,13.87775 0.295401554,13.68975 C0.0724015543,13.46775 -0.0315984457,13.16075 0.00840155428,12.84775 L0.487401554,9.32875 C0.515401554,9.11275 0.617401554,8.90775 0.772401554,8.75375 Z M7.81140155,4.55175 L2.42840155,9.93375 L2.17440155,11.80875 L4.04940155,11.55375 L9.43140155,6.17275 L7.81140155,4.55175 Z M10.2714016,2.09175 L9.22940155,3.13375 L10.8494016,4.75375 L11.8904016,3.71275 L10.2714016,2.09175 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.00020155427599899411 -0.0001499999999996504)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.000201554276,0.00015 14.0002016,0.00015 14.0002016,13.98175 0.000201554276,13.98175 0.000201554276,0.00015",
    stroke: "none",
    fill: "current"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c1b3d4b4d4e318fa3fd48034ddc99bc5.svg";
export { ForwardRef as ReactComponent };